module.exports = __webpack_public_path__ + "static/media/dialer_2.7ce63411.ico";